import {
  Interview,
  CreateInterviewRequest,
  GetInterviewsParams,
  PaginatedResponse,
  ApiValidationError,
  ValidationError,
} from "../types/interview";
import { msalInstance } from "../AuthProvider";
import { apiRequest } from "../authConfig";

const API_BASE_URL = import.meta.env.REACT_APP_API_BASE_URL || "/api";
const USE_MOCK_DATA = import.meta.env.REACT_APP_USE_MOCK_DATA === "true";
const INTERVIEW_BASE_URL = import.meta.env.REACT_APP_INTERVIEW_BASE_URL || "http://localhost:3000/";

// Mock data for development/testing
const mockInterviews: Interview[] = [
  {
    id: "1",
    jobId: "0012345678",
    firstName: "John",
    lastName: "Smith",
    email: "john.smith@email.com",
    createdDate: "2025-11-15T14:00:00Z",
    completedDate: "2025-11-16T09:30:00Z",
    status: "completed",
    expiryDate: "2025-11-20T14:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/1`,
  },
  {
    id: "2",
    jobId: "0012345679",
    firstName: "Jane",
    lastName: "Doe",
    email: "jane.doe@email.com",
    createdDate: "2025-11-14T09:00:00Z",
    status: "pending",
    expiryDate: "2025-11-19T09:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/2`,
  },
  {
    id: "3",
    jobId: "0012345680",
    firstName: "Bob",
    lastName: "Johnson",
    email: "bob.johnson@email.com",
    createdDate: "2025-11-10T11:00:00Z",
    status: "expired",
    expiryDate: "2025-11-15T11:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/3`,
  },
  {
    id: "4",
    jobId: "0012345681",
    firstName: "Alice",
    lastName: "Williams",
    email: "alice.williams@email.com",
    createdDate: "2025-11-12T10:00:00Z",
    status: "pending",
    expiryDate: "2025-11-17T10:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/4`,
  },
  {
    id: "5",
    jobId: "0012345682",
    firstName: "Charlie",
    lastName: "Brown",
    email: "charlie.brown@email.com",
    createdDate: "2025-11-11T15:30:00Z",
    completedDate: "2025-11-12T11:00:00Z",
    status: "completed",
    expiryDate: "2025-11-16T15:30:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/5`,
  },
  {
    id: "6",
    jobId: "0012345683",
    firstName: "Diana",
    lastName: "Martinez",
    email: "diana.martinez@email.com",
    createdDate: "2025-11-09T08:00:00Z",
    status: "expired",
    expiryDate: "2025-11-14T08:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/6`,
  },
  {
    id: "7",
    jobId: "0012345684",
    firstName: "Edward",
    lastName: "Garcia",
    email: "edward.garcia@email.com",
    createdDate: "2025-11-13T12:00:00Z",
    status: "pending",
    expiryDate: "2025-11-18T12:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/7`,
  },
  {
    id: "8",
    jobId: "0012345685",
    firstName: "Fiona",
    lastName: "Anderson",
    email: "fiona.anderson@email.com",
    createdDate: "2025-11-08T16:00:00Z",
    completedDate: "2025-11-09T10:30:00Z",
    status: "completed",
    expiryDate: "2025-11-13T16:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/8`,
  },
  {
    id: "9",
    jobId: "0012345686",
    firstName: "George",
    lastName: "Taylor",
    email: "george.taylor@email.com",
    createdDate: "2025-11-07T09:00:00Z",
    status: "expired",
    expiryDate: "2025-11-12T09:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/9`,
  },
  {
    id: "10",
    jobId: "0012345687",
    firstName: "Hannah",
    lastName: "Thomas",
    email: "hannah.thomas@email.com",
    createdDate: "2025-11-16T11:00:00Z",
    status: "pending",
    expiryDate: "2025-11-21T11:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/10`,
  },
  {
    id: "11",
    jobId: "0012345688",
    firstName: "Isaac",
    lastName: "Moore",
    email: "isaac.moore@email.com",
    createdDate: "2025-11-06T14:00:00Z",
    completedDate: "2025-11-07T09:00:00Z",
    status: "completed",
    expiryDate: "2025-11-11T14:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/11`,
  },
  {
    id: "12",
    jobId: "0012345689",
    firstName: "Julia",
    lastName: "Jackson",
    email: "julia.jackson@email.com",
    createdDate: "2025-11-05T13:00:00Z",
    status: "expired",
    expiryDate: "2025-11-10T13:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/12`,
  },
  {
    id: "13",
    jobId: "0012345690",
    firstName: "Kevin",
    lastName: "White",
    email: "kevin.white@email.com",
    createdDate: "2025-11-17T10:00:00Z",
    status: "pending",
    expiryDate: "2025-11-22T10:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/13`,
  },
  {
    id: "14",
    jobId: "0012345691",
    firstName: "Laura",
    lastName: "Harris",
    email: "laura.harris@email.com",
    createdDate: "2025-11-04T17:00:00Z",
    completedDate: "2025-11-05T14:00:00Z",
    status: "completed",
    expiryDate: "2025-11-09T17:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/14`,
  },
  {
    id: "15",
    jobId: "0012345692",
    firstName: "Michael",
    lastName: "Clark",
    email: "michael.clark@email.com",
    createdDate: "2025-11-03T08:30:00Z",
    status: "expired",
    expiryDate: "2025-11-08T08:30:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/15`,
  },
  {
    id: "16",
    jobId: "0012345693",
    firstName: "Nancy",
    lastName: "Lewis",
    email: "nancy.lewis@email.com",
    createdDate: "2025-11-18T09:00:00Z",
    status: "pending",
    expiryDate: "2025-11-23T09:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/16`,
  },
  {
    id: "17",
    jobId: "0012345694",
    firstName: "Oliver",
    lastName: "Robinson",
    email: "oliver.robinson@email.com",
    createdDate: "2025-11-02T11:00:00Z",
    completedDate: "2025-11-03T16:00:00Z",
    status: "completed",
    expiryDate: "2025-11-07T11:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/17`,
  },
  {
    id: "18",
    jobId: "0012345695",
    firstName: "Patricia",
    lastName: "Lee",
    email: "patricia.lee@email.com",
    createdDate: "2025-11-19T14:30:00Z",
    status: "inprogress",
    expiryDate: "2025-11-24T14:30:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/18`,
  },
  {
    id: "19",
    jobId: "0012345696",
    firstName: "Quincy",
    lastName: "Adams",
    email: "quincy.adams@email.com",
    createdDate: "2025-11-18T10:00:00Z",
    status: "interrupted",
    expiryDate: "2025-11-23T10:00:00Z",
    interviewUrl: `${INTERVIEW_BASE_URL}session/19`,
  },
];

// Sort interviews: pending first, then by createdDate descending
const sortInterviews = (interviews: Interview[]): Interview[] => {
  return [...interviews].sort((a, b) => {
    if (a.status === "pending" && b.status !== "pending") return -1;
    if (a.status !== "pending" && b.status === "pending") return 1;
    return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
  });
};

// Helper to create mock paginated response with optional search
const getMockPaginatedResponse = (page: number, pageSize: number, search?: string): PaginatedResponse<Interview> => {
  let filteredData = mockInterviews;

  if (search) {
    const query = search.toLowerCase();
    filteredData = mockInterviews.filter((interview) => {
      const fullName = `${interview.firstName} ${interview.lastName}`.toLowerCase();
      return (
        interview.jobId.toLowerCase().includes(query) ||
        fullName.includes(query) ||
        interview.firstName.toLowerCase().includes(query) ||
        interview.lastName.toLowerCase().includes(query)
      );
    });
  }

  const sortedData = sortInterviews(filteredData);
  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedData = sortedData.slice(startIndex, endIndex);

  return {
    pagination: {
      page,
      pageSize,
      totalPages: Math.ceil(sortedData.length / pageSize),
      totalCount: sortedData.length,
    },
    data: paginatedData,
  };
};

// Generate a fake PDF for mock download
const generateMockPdf = (id: string): Blob => {
  const content = `Mock Interview Report\n\nInterview ID: ${id}\nGenerated: ${new Date().toISOString()}\n\nThis is a mock PDF file for testing purposes.`;
  return new Blob([content], { type: "application/pdf" });
};

class InterviewService {
  private baseUrl = `${API_BASE_URL}/interviews`;

  private async getAccessToken(): Promise<string> {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error("No active account! Please sign in.");
    }

    try {
      const response = await msalInstance.acquireTokenSilent({
        ...apiRequest,
        account: accounts[0],
      });
      return response.accessToken;
    } catch (error) {
      // If silent token acquisition fails, try interactive
      const response = await msalInstance.acquireTokenPopup(apiRequest);
      return response.accessToken;
    }
  }

  private async getAuthHeaders(): Promise<HeadersInit> {
    const token = await this.getAccessToken();
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  }

  async getAll(params: GetInterviewsParams = {}): Promise<PaginatedResponse<Interview>> {
    const { page = 1, pageSize = 10, search } = params;

    // Return mock data if flag is set
    if (USE_MOCK_DATA) {
      return getMockPaginatedResponse(page, pageSize, search);
    }

    const queryParams = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
    });

    if (search) {
      queryParams.append("search", search);
    }

    const headers = await this.getAuthHeaders();
    const response = await fetch(`${this.baseUrl}?${queryParams}`, { headers });
    if (!response.ok) {
      throw new Error("Failed to fetch interviews");
    }
    return response.json();
  }

  async create(data: CreateInterviewRequest): Promise<Interview> {
    // Return mock created interview if flag is set
    if (USE_MOCK_DATA) {
      const mockId = `mock-${Date.now()}`;
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 5);

      return {
        id: mockId,
        jobId: data.jobId,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        createdDate: new Date().toISOString(),
        status: "pending",
        expiryDate: expiryDate.toISOString(),
        interviewUrl: `${INTERVIEW_BASE_URL}session/${mockId}`,
      };
    }

    const headers = await this.getAuthHeaders();
    const response = await fetch(this.baseUrl, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData: ApiValidationError = await response.json();

      if (errorData.errors) {
        throw new ValidationError(errorData.title, errorData.errors);
      }

      throw new Error(errorData.title || "Failed to create interview");
    }

    return response.json();
  }

  async download(id: string): Promise<void> {
    // Generate fake PDF if mock mode is enabled
    if (USE_MOCK_DATA) {
      const blob = generateMockPdf(id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `mock-interview-${id}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return;
    }

    const token = await this.getAccessToken();
    const response = await fetch(`${API_BASE_URL}/download/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to download interview with id: ${id}`);
    }

    const blob = await response.blob();
    const contentDisposition = response.headers.get("Content-Disposition");
    let filename = `interview-${id}.pdf`;

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}

export const interviewService = new InterviewService();
export default interviewService;
